module.exports = __webpack_public_path__ + "img/v4_trade3.a4024e86.png";